import { node } from "prop-types";
import React from "react";

const CardPriceHead = ({ children }) => <div className="card-price-content__head">{children}</div>;

CardPriceHead.propTypes = {
	children: node.isRequired,
};

export default CardPriceHead;
